import {ENDPOINT_ADMIN_TRX_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const loopMap = require('mn-utils/loopMap');
const {
  apiRequestAdmin,
} = require('../ws');


const MOCK_TRANSACTION = loopMap(100, (i) => {
  const id = '' + (1 + i);
  return {
    id: '24286723-46435-43545-3454423-2343' + id,
    time: '2020-02-17T12:07',
    hash: '0x238b0476aae71ec1e9c055806f1765d5b7dc0d2fbaabebd7e224302f1afda340',
    fee: 100,
    coin: 'ETH',
    value_cc: 100,
    fiat: 'EUR',
    value_fiat: 100,
    company_name: 'company name',
    username: 'username',
  };
});


export function apiAdminTransactionsList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {
      list: MOCK_TRANSACTION.slice(offset, offset + limit),
      count: MOCK_TRANSACTION.length,
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_TRX_LIST, {
    ...params,
    offset,
    limit,
  });
}
